import React, { FC } from "react";
import Form from "react-bootstrap/Form";
import TextField from "@mui/material/TextField";
import { Input, InputLabel, FormControl } from "@mui/material";
import { DatePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";

interface IInputDateOnlyPicker {
  controlId: string;
  label: string;
  placeholder: string;
  handleChange: any;
  handleClose: any;
  handleBlur: any;
  errorsField: any;
  touched: any;
  value: any;
  autofocus?: any;
  readOnly?: any;
  disabled?: any;
}

/**
 * Input Type Text Reusable Component
 *
 * @param {{ controlId: any; label: any; placeholder: any; handleChange: any; handleClose: any; handleBlur: any; errorsField: any; touched: any; }} {
    controlId, label, placeholder, handleChange, handleBlur, errorsField, touched, readOnly, disabled
}
 * @returns {*}
 */
const InputDateOnlyPicker: FC<IInputDateOnlyPicker> = ({
  controlId,
  label,
  placeholder,
  handleChange,
  handleClose,
  handleBlur,
  errorsField,
  touched,
  value,
  autofocus,
  readOnly,
  disabled,
}) => {
  return (
    <FormControl fullWidth error={errorsField && touched}>
      <Form.Group className="mb-3 pb-1" controlId={controlId}>
        <div className="position-relative date-picker-icon"></div>
        <DatePicker
          name={controlId}
          onChange={handleChange}
          placeholder={placeholder}
          format="MM/dd/yyyy"
        />
      </Form.Group>
    </FormControl>
  );
};

export default InputDateOnlyPicker;
